import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { Box, Toolbar } from "@mui/material";
import Drawer from "../MainLayout/Drawer";
import Header from "../MainLayout/Header";
import { openDrawer } from "store/reducers/menu";
import { useDynamicBreakpoints } from "../../utils/breakpointUtils";

const ProvisioningLayout = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = JSON.parse(localStorage.getItem("user"));
    const isUser = user && user?.role === "";
    const { drawerOpen } = useSelector((state) => state.menu);
    const { isLoggedIn } = useSelector((state) => state.auth);

    const { matchDownSM, matchDownMD, matchDownLG } = useDynamicBreakpoints(drawerOpen);

    const handleDrawerToggle = () => {
        dispatch(openDrawer({ drawerOpen: !drawerOpen }));
    };

    useEffect(() => {
        if (!isLoggedIn) {
            navigate("/login");
        }
    }, [isLoggedIn, navigate]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 800 && drawerOpen) {
                dispatch(openDrawer({ drawerOpen: false }));
            }
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [drawerOpen, dispatch]);

    return (
        // Stack the header ABOVE the content, like MainLayout. The header is
        // position:sticky (in-flow), so as a horizontal flex sibling of <main> it
        // reserved a full-width column and pushed the wizard off-screen to the right.
        // Provisioning renders no Drawer, so main is full width and the header spans
        // full width (open=false, no 260px drawer offset).
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", minHeight: "100vh", bgcolor: 'background.default' }}>
            <Box>
                <Header open={false} />
            </Box>
            <Box component="main" sx={{ width: "100%", flexGrow: 1, p: { xs: 2, sm: 3 }, mt: -2 }}>
                <Toolbar
                    sx={{
                        minHeight: '50px !important',
                        height: '50px',
                    }}
                />
                <Outlet />
            </Box>
        </Box>
    );
};

export default ProvisioningLayout;